import { Route, Switch, useRouteMatch } from 'react-router-dom';

import FundingSingle from '@pages/funding/single/FundingSingle';
import FundingList from '@pages/funding/list/FundingList';

const FundingRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}`}>
                <FundingList />
            </Route>
            <Route exact path={`${path}/:id`}>
                <FundingSingle />
            </Route>
        </Switch>
    );
};

export default FundingRoutes;
